import React from 'react';
import { SpecLogo } from '../icons';
import './PoweredBySpec.css';

export interface PoweredBySpecProps {
    /** Additional CSS class */
    className?: string;
}

export const PoweredBySpec: React.FC<PoweredBySpecProps> = ({ className = '' }) => {
    return (
        <div className={`powered-by-spec ${className}`}>
            <h6 className="powered-by-spec__text">Powered by</h6>
            <SpecLogo />
        </div>
    );
};
